import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_3 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "flex-grow-1 ms-3" }
const _hoisted_7 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_8 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_9 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "flex-grow-1 ms-3" }
const _hoisted_13 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_14 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_15 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "flex-grow-1 ms-3" }
const _hoisted_19 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_20 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_21 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "flex-grow-1 ms-3" }
const _hoisted_25 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_26 = { class: "col-lg-8 mb-25" }
const _hoisted_27 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_28 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_29 = { style: {"width":"200px"} }
const _hoisted_30 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_31 = { class: "performance-chart" }
const _hoisted_32 = {
  ref: "performanceChart",
  width: "400",
  height: "200"
}
const _hoisted_33 = { class: "col-lg-4 mb-25" }
const _hoisted_34 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_35 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_36 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_37 = {
  key: 1,
  class: "alerts-list"
}
const _hoisted_38 = { class: "d-flex align-items-start" }
const _hoisted_39 = { class: "flex-grow-1" }
const _hoisted_40 = { class: "fw-medium" }
const _hoisted_41 = { class: "small text-muted" }
const _hoisted_42 = { class: "small text-muted" }
const _hoisted_43 = { class: "col-12 mb-25" }
const _hoisted_44 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_45 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_46 = { class: "d-flex align-items-center gap-2" }
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_49 = { class: "table-responsive" }
const _hoisted_50 = { class: "table align-middle mb-0" }
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = { class: "fw-medium" }
const _hoisted_53 = { class: "small text-muted" }
const _hoisted_54 = { class: "badge bg-primary" }
const _hoisted_55 = { class: "badge bg-warning" }
const _hoisted_56 = { class: "badge bg-info" }
const _hoisted_57 = { class: "badge bg-success" }
const _hoisted_58 = { class: "badge bg-success" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-users text-primary",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.stats.totalAgents), 1),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Agents actifs", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-folder text-warning",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.stats.totalQueues), 1),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Files de validation", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-time text-info",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.stats.pendingValidation), 1),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "En attente validation", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-check text-success",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.stats.validatedToday), 1),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Validés aujourd'hui", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Performance des Agents", -1)),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedPeriod,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
              options: _ctx.periodOptions,
              searchable: false,
              "close-on-select": true,
              placeholder: "Sélectionner une période",
              onChange: _ctx.loadPerformanceData
            }, null, 8, ["modelValue", "options", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("canvas", _hoisted_32, null, 512)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }, [
          _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Alertes")
        ], -1)),
        _createElementVNode("div", _hoisted_35, [
          (_ctx.alerts.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("i", {
                  class: "flaticon-check-circle text-success",
                  style: {"font-size":"48px"}
                }, null, -1),
                _createElementVNode("p", { class: "text-muted mt-2" }, "Aucune alerte", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: alert.id,
                    class: _normalizeClass(["alert-item", _ctx.getAlertClass(alert.type)])
                  }, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.getAlertIcon(alert.type), "me-2 mt-1"])
                      }, null, 2),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(alert.title), 1),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(alert.message), 1),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.formatDate(alert.created_at)), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Performance des Agents", -1)),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("small", _hoisted_47, "Période: " + _toDisplayString(_ctx.selectedPeriod) + " jours", 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadSupervisorData && _ctx.loadSupervisorData(...args))),
              class: "btn btn-primary btn-sm"
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
              _createTextVNode(" Actualiser ", -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("table", _hoisted_50, [
              _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Agent"),
                  _createElementVNode("th", null, "Files assignées"),
                  _createElementVNode("th", null, "Tâches génériques (en cours)"),
                  _createElementVNode("th", null, "Dossiers spécifiques (en cours)"),
                  _createElementVNode("th", null, "Dossiers complétés"),
                  _createElementVNode("th", null, "Tâches génériques complétées")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentPerformances, (agent) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: agent.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_51, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "agent-avatar me-2" }, [
                          _createElementVNode("i", { class: "flaticon-user-1" })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_52, _toDisplayString(agent.nom) + " " + _toDisplayString(agent.prenom), 1),
                          _createElementVNode("div", _hoisted_53, _toDisplayString(agent.email), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_54, _toDisplayString(agent.assignedQueues), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(agent.genericTasksInProgress), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_56, _toDisplayString(agent.specificDossiersInProgress), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_57, _toDisplayString(agent.completedDossiers), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_58, _toDisplayString(agent.completedGenericTasks), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}